import { useContext } from "react";

import { MessageContext } from "@contexts/Message";

const useMessage = () => {
  return useContext(MessageContext);
};

export default useMessage;
